import users from './users';
import del from './delete';
import get from './get';
import put from './put';

export default { users, del, get, put };
